import NewProofTaxRegime from "./newProofTaxRegime";
export default NewProofTaxRegime;